module.exports = "/assets/67232b9410212c7a8c0583fec03345c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/PH.png
// module id = 1716
// module chunks = 0